import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, LinkData } from '../../../types'
import { CmsConverterService, defaultLinkData } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ColorContainerRelatedItemLinkConverter extends CmsConverterService<ColorContainerRelatedItemLinkData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const link = formData.st_input_link ?? defaultLinkData
    const previewId = source.otherProperties.previewId ?? ''
    return {
      fullWidth: formData.st_full_width?.value ?? false,
      link: {
        ...link,
        uuid: previewId.substring(0, previewId.indexOf('.')),
        assetType: link.assetType || (link.mime === 'application/pdf' ? 'PDF' : ''),
        assetName: link.assetName || link.text || '',
      }
    }
  }
}

export const COLOR_CONTAINER_RELATED_ITEM_LINK_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ColorContainerRelatedItemLinkData>>('RelatedItemLinkConverter')

export interface ColorContainerRelatedItemLinkData extends ConvertedComponentData {
  link: LinkData;
  fullWidth: boolean;
  fsCatalogIndex?: number;
}
